import React from "react";

/**
 * Logo Vénus Médical — V ailé officiel (violet/rose dégradé)
 * Affiche le PNG haute définition depuis /logo192.png (servi par le frontend)
 * Usage : <VenusLogo size={32} className="rounded-xl" />
 */
export default function VenusLogo({ size = 32, className = "" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/logo192.png`}
      width={size}
      height={Math.round(size * 0.92)}
      alt="Vénus Médical"
      className={className}
      style={{ objectFit: "contain", display: "block" }}
      draggable={false}
    />
  );
}
